import { adminHttpClient } from '../../commons/adminHttpClient'
import { ExpenseTypeEligibility } from 'domain/expenses/expenseTypeEligibility'

export interface AddDefaultExpenseTypeRequest {
  name: string
  active: boolean
  hraEligible: boolean
  eligibility: ExpenseTypeEligibility
  productId: number
  expenseCategoryId: number
  aiAutoVerifyEnabled: boolean
}

const addDefaultExpenseType = (request: AddDefaultExpenseTypeRequest): Promise<number> =>
  adminHttpClient.post('Expenses/DefaultExpenseTypes', request)

export default addDefaultExpenseType
